import type { ConnectorTranslations } from "../../types/connectors";

export const connectors: ConnectorTranslations = {
  title: "Ühenda Frankliniga",
  description: "Vali, millele see rakendus sinu Franklini kontoga ligi pääseb.",
  client: "Rakendus",
  clientIdentity: "Kliendi ID",
  clientNotice: "Rakendus määrab oma nime ise. Ühenda ainult rakendus, mida tunned ja usaldad.",
  account: "Sisse logitud kasutajana",
  organization: "Organisatsioon",
  chooseOrganization: "Vali organisatsioon",
  permissions: "Õigused",
  permissionNotice:
    "Sinu kehtivad Franklini õigused kehtivad alati. Juurdepääsu saad igal ajal ühendatud rakenduste alt tühistada.",
  persistentAccess: "Ühendus jääb aktiivseks, kuni selle tühistad või sinu juurdepääs aegub.",
  noOrganizations:
    "Rakenduse ühendamiseks pead olema organisatsiooni aktiivne liige. Võid taotluse tagasi lükata ja rakendusse naasta.",
  allow: "Luba juurdepääs",
  deny: "Keeldu",
  pending: "Palun oota…",
  loading: "Ühenduse andmete laadimine…",
  unavailable: "Ühendused pole selles keskkonnas veel saadaval.",
  expired: "Ühenduse taotlus on vigane või aegunud. Alusta rakendusest uut ühendamist.",
  failed:
    "Taotlust ei saanud lõpule viia. Proovi uuesti. Kui sinu õigused on muutunud, alusta rakendusest uut ühendamist.",
  retry: "Proovi uuesti",
  connectedTitle: "Ühendatud rakendused",
  connectedDescription: "Halda rakendusi, millel on sinu konto kaudu juurdepääs Franklinile.",
  empty: "Ühendatud rakendusi veel pole. Alustamiseks lisa Franklin oma rakenduses.",
  unnamed: "Nimetu rakendus",
  created: "Ühendatud",
  lastUsed: "Viimati kasutatud",
  neverUsed: "Pole veel kasutatud",
  revoked: "Juurdepääs tühistatud",
  revoke: "Tühista juurdepääs",
  revokeTitle: "Kas tühistada rakenduse juurdepääs?",
  revokeDescription:
    "See ühendus lõpetab kohe töötamise. Uuesti kasutamiseks ühenda rakendus ja anna sellele uuesti luba.",
  cancel: "Loobu",
  revokedSuccess: "Juurdepääs tühistatud.",
  more: "Laadi rohkem",
  settings: "Halda ühendatud rakendusi",
  uploadTitle: "Laadi fail Franklini",
  uploadDescription: "Vali ühendatud rakenduse taotletud fail.",
  uploadFile: "Taotletud fail",
  uploadBytes: "baiti",
  uploadDestination: "Sihtkoht",
  uploadNotice:
    "Lisatakse uus dokument. Olemasolevad failid ja versioonid säilivad. Saad üleslaadimise peatada ja jätkata sama faili uuesti valides.",
  uploadComplete: "Fail on üles laaditud. Naase ühendatud rakendusse.",
  uploadClosed:
    "See üleslaadimine tühistati või on aegunud. Taotle ühendatud rakenduses uut üleslaadimist.",
  uploadChoose: "Vali fail",
  uploadMismatch: "Vali taotletud nime ja täpse suurusega fail.",
  uploadProgress: "Üleslaadimise edenemine",
  uploadFailed:
    "Üleslaadimine ebaõnnestus. Kontrolli ühendust ja jätka. Kui ligipääs on muutunud, taotle uut üleslaadimist.",
  uploadPause: "Peata üleslaadimine",
  uploadStart: "Laadi üles või jätka",
  uploadCancel: "Tühista üleslaadimine",
  actionTitle: "Vaata taotletud muudatus üle",
  actionDescription: "Ühendatud rakendus soovib teha Franklinis järgmise muudatuse.",
  actionPreview: "Kavandatud muudatus",
  actionParameters: "Kõik taotluse üksikasjad",
  actionNotice:
    "Kinnitus kehtib üks kord täpselt sellele taotlusele ja aegub 15 minuti pärast. Franklin kontrollib enne muudatuse tegemist sinu õigusi uuesti.",
  approveAction: "Kinnita see muudatus",
  actionStates: {
    approved: "Kinnitatud. Toimingu lõpetamiseks naase ühendatud rakendusse.",
    denied: "Taotlus lükati tagasi. Muudatust ei tehtud.",
    cancelled: "See taotlus tühistati.",
    succeeded: "See toiming on lõpetatud.",
    conflicted:
      "Sihtobjekt või kavandatud muudatus on muutunud. Küsi ühendatud rakenduselt uut eelvaadet.",
    expired: "Taotlus on aegunud. Küsi ühendatud rakenduselt uut eelvaadet.",
  },
  scopes: {
    "franklin.read": "Loe teavet, millele sul on juurdepääs",
    "franklin.write": "Loo ja muuda teavet",
    "franklin.share": "Jaga teavet teistega",
    "franklin.admin": "Halda organisatsiooni seadeid ja juurdepääsu",
    "franklin.sign": "Taotle allkirju ja halda allkirjastamist",
    "franklin.billing": "Vaata arveldusteavet",
  },
};
